export const DistributionListTypes = {
  DONATION: { text: 'Donation', value: 'donation' },
  LIQUIDATION: { text: 'Liquidation', value: 'liquidation' },
};
